export function populateTemplatePlaceholders(templateString, formValues) {
  return templateString.replace(/\[([^\]]+)]/g, (_, key) => {
    let value = formValues[key] || `[${key}]`;
    // Convert to Title Case to improve PII Scrubber effectiveness
    if (key === 'name' && value) {
      value = value
        .split(' ')
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(' ');
    }
    return value;
  });
}
